const Form068SC = {
    form: "有关资助中学或特殊学校高于核准职级的校长／降职晋升职级教师／降职一级实验室技术员20xx／yy学年的特别支薪安排的申请",

    errorMsg: {
        "E-0106": "AA000000(A)",
        "E-0105": "数字是不允许的。",
        "E-0104": "仅包含中文字符。数字是不允许的。",
        "E-0103": "只允许输入29 - 41.",
        "E-0102": "只允许输入25 - 41",
        "E-0101": "请输入正确数字",
        "E-0100": "只允许输入14 - 41。",
        "E-0099": "只允许输入14 - 39。",
        "E-0107": "降职／晋升前后的职级不能相同",
        "E-0108": "Please select a date between 01/08 and 30/09",
        reason: "请输入一个有效的注明",
    },

    stepName: {
        ImportantNotes: "重要提示",
        action: "行动",
        note: "注意",
        information: "资料",
        confirmation: "确认",
    },
    businessTypes: {},
    label: {
        applicationForm: "申请表",
        note: "注意",
        schoolChoice: {
            ManagementCommittee: "学校管理委员会",
            Incorporated: "法团管理委员会",
        },

        ActionToBeTakenList: {
            1: "重新部署职位过高的员工，以填补因同一学校一名员工退休／辞职／合同终止而出现的空缺。",
            2: "将职级过高的职员重新调配，以填补同一所学校拟增设的相应职级的新职位，原因是",
            3: "重新部署职位过高的教员，以填补同一赞助机构下另一所学校的教员退休／辞职／合同终止所造成的空缺。",
            4: "将职级过高的职员重新调配，以填补在同一资助机构辖下另一所学校开设的相应职级的新职位，原因如下",
            5: "职位过高的员工会加入工作分享。",
            6: "职位过高的员工将会退休／辞职。",
            7: "其他措施",
        },

        IncrementalDateList: {
            1: "01",
            2: "02",
            3: "03",
            4: "04",
            5: "05",
            6: "06",
            7: "07",
            8: "08",
            9: "09",
            10: "10",
            11: "11",
            12: "12",
        },
        conditions: "本人已阅读、理解及同意上述条款及细则",
        noteList: {
            note1: "1:请适当删除。",
            note2: "2:薪级点不超过职级最高薪级点的离职员工，可按职级的薪级进行。",
            note3: "3:不包括责任津贴（如有）",
            note4:
                "4:涉及基本职等以上一级教师（如PGM）而下一级教师没有空缺时，有关学校有权决定是否留用" +
                "老师降职超过一个级别，或有一系列降职涉及到不止一个老师，直到 " +
                "这个权利没有被超越。做出的决定应该有充分的理由支持。上诉" +
                "机制也应该到位。所有这些都应该让学校的老师知道，并适当地" +
                "作为对可能出现的任何不公平或不正当指控的保障。",
            note5: "5:不再符合资格领取先前享有的责任津贴(如有的话)。",
            note6: "6:只适用于收讫点尚未超过职级最高收讫点的离职员工。",
            note7: "7:请参阅所附附件并输入代码编号。",
            note8: "8:如果该学年不是2021／22学年，学校还应附加一个计划关于如何纠正的情况，列出预期的空置情况推广跻身在同样的学校赞助机构（如适用）在未来学校年。",

            note0: "我确认：",
            notea: "（一） EDBCM第46／2020号规定的富余人员选拔安排已被遵守；",
            noteb:
                "（二）学校内或同级学校没有有关职级的空缺" +
                "s2020／21学年重新部署的赞助机构。各自的空缺情况" +
                "学校内及同一赞助机构下的学校之间的晋升等级（如果 " +
                "适用）连接",
            notec: "（三）已将上述特别及临时安排通知离职人员；",
            noted: "（四）本表格内的资料包括修正计划均属正确；",
            notee: "（五）离职员工在2020／21学年的职责将尽可能与其工资相称；和",
            notef: "（六）学校须将多缴的薪金补助金退还教育局。",
        },
    },
    information: {
        CSDO: "总学校发展主任",
        Date: "日期",
        ManagementCommittee: "学校管理委员会／法团管理委员会",
        HKIDNo: "身份证号码",
        EnglishName: "英文名",
        ChineseName: "中文名称",
        pleaseSpecify: "请注明",
        firstSchoolYear:
            "如2022年8月31日或之前已降職，填上<b>首次</b>獲批特別支薪安排的學年",
        Ranks: "职级",
        Salary: "薪金",
        //SalaryBar: "薪酬关限",
        MaxSalary: "顶薪点",
        IncrementalDate: "增薪日期",
        EffectiveDateFrom: "生效日期",
        EffectiveDateTo: "生效日期至",

        Rank: "职员参考编号",
        Salary3: "薪金",
        // SalaryBars: "薪酬关限",
        MaxSalarys: "顶薪点",
        IncrementalDates: "增薪日期",
        DateOfNextIncrement: "下次增薪日期",
        ActionToBeTaken: "措施",
        ProposedSchoolYear: "建议学年",
        attachment: "副本",
        formConfirm: "本人确认：",

        Notes1: "截至{{year}}年8月31日",
        Notes2: "2020年9月1日至2021年8月31日卸任后生效（如有必要，请修改此期限）。",
        Notes3: "修正计划",
    },
    SalaryList: {
        25: "51,095",
        26: "53,500",
        27: "55,995",
        28: "58,635",
        29: "61,415",
        30: "64,270",
        31: "67,295",
        32: "70,465",
        33: "73,775",
        34: "74,515",
        35: "75,265",
        36: "78,385",
        37: "82,105",
        38: "85,870",
        39: "89,845",
        40: "93,710",
        41: "97,745",
    },
    CSDOValue: {
        0: "北区",
        1: "葵青区",
        2: "西贡区",
        3: "东区",
        4: "屯门区",
        5: "九龙城区",
        6: "观塘区",
        7: "南区",
        8: "油尖旺区",
        9: "荃湾区",
        10: "沙田区",
        11: "深水埗区",
        12: "大埔区",
        13: "湾仔区",
        14: "离岛区",
        15: "中西区",
        16: "元朗区",
        17: "黄大仙区",
    },
    confirmStatementList: {
        statement1: "已参照教育局第46／2020号所载有关拣选过剩教职员的安排；",
        statement2:
            "办学团体其他辖下学校于2020／21学年没有可供调配的合适职级的空缺，并夹附本校及办学团体属校的相关晋升职级空缺情况（如适用）；",
        statement3: "已通知降职教职员有关上述特殊的临时安排；",
        statement4: "本表格内所载的资料包括修正计划均属正确无误；",
        statement5:
            "须降职的教职员在2020／21学年的职务，会尽量与其薪酬相称；以及",
        statement6: "本校会把任何多付的薪金津贴退还教育局。",
    },
    tooltipList: {
        tooltip1: "请删去不适用者。",
        tooltip2:
            "降职教职员的支薪点如尚未达到降职后所属职级的顶薪点，可按照降职后所属职级的薪级表继续增薪。",
        tooltip3: "不包括责任津贴(如有)。",
        tooltip4:
            "如须降职的晋升职级教师的职级超出基本职级多于一级(例如首席学位教师)，而学校并无职位空缺让该晋升职级教师只降低一级，则学校有酌情权，决定是否把该晋升职级教师降职多于一级，或安排多于一位晋升职级教师进行一连串降职，直到不超出核准编制为止。学校必须有充分理据支持所作的决定，亦应设立上诉机制。有关的安排应让校内全体教师知悉，并妥为记录，以便日后如被指处事不公平或不适当，可作证明之用。",
        tooltip5: "不再合资格领取以前可享有的责任津贴(如有)。",
        tooltip6:
            "只适用于降职教职员，但其支薪点尚未超越降职后所属职级的顶薪点。",
        tooltip7:
            "1至6项所列举的措施仅供学校参考，并非尽录无遗。校方请于7第项内注明其他建议措施，以有效修正高于核准职级的情况。",
        tooltip8:
            "如建议学年非2021/22学年，学校需另行提交文件详细说明修正高于核准职级情况的计划及所属办学团体其他属校于未来学年预计于各晋升职级出现的空缺(如适用)的详情。",
    },
};
export default Form068SC;
